import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, BehaviorSubject, throwError } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private accessToken = new BehaviorSubject<string | null>(null);
  private refreshToken = localStorage.getItem('refresh_token');

  constructor(private http: HttpClient) {}

  headers = new HttpHeaders({
    'Content-Type': 'application/json', // Set appropriate content type
  });

  // Method to log in and get tokens
  login(username: string, password: string): Observable<any> {
    return this.http
      .post<any>(
        `${environment.keycloakUrl}/realms/${environment.keyCloak.realmName}`,
        { username, password, client_id: 'web_app', grant_type: 'password' },
        { headers: this.headers }
      )
      .pipe(
        tap((response) => {
          this.setTokens(response.accessToken, response.refreshToken);
        })
      );
  }

  // Method to refresh the access token
  refreshAccessToken(): Observable<any> {
    return this.http
      .post<any>(`${environment.keycloakUrl}/realms/${environment.keyCloak.realmName}/protocol/openid-connect/token`, {
        refreshToken: this.refreshToken,
      })
      .pipe(
        tap((response) => {
          this.setTokens(response.accessToken, this.refreshToken as string);
        })
      );
  }

  // Method to set tokens in local storage
  private setTokens(accessToken: string, refreshToken: string): void {
    this.accessToken.next(accessToken);
    localStorage.setItem('refresh_token', refreshToken);
  }

  // Method to get the current access token
  getAccessToken(): string | null {
    return this.accessToken.getValue();
  }

  // Method to handle logout
  logout(): void {
    this.accessToken.next(null);
    localStorage.removeItem('refresh_token');
  }
}
